/**
 * Route guard: renders children only if the current user is authenticated and
 * (optionally) has an allowed role. Otherwise redirects to /ops/login.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useOpsAuth } from './OpsAuthContext';

export const OpsProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useOpsAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="ops-loading"
        className="min-h-screen flex items-center justify-center bg-[#FAFAF7]"
      >
        <div className="text-[#5C6D49] font-['Noto_Kufi_Arabic'] text-sm">
          جارٍ التحقق من الجلسة…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/ops/login" state={{ from: location.pathname }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return (
      <div
        data-testid="ops-forbidden"
        dir="rtl"
        className="min-h-screen flex items-center justify-center bg-[#FAFAF7] px-6"
      >
        <div className="max-w-md text-center">
          <h2 className="font-['Playfair_Display'] text-3xl text-[#1F3D2B] font-semibold mb-3">
            الوصول مرفوض
          </h2>
          <p className="text-[#5C6D49] font-['Noto_Kufi_Arabic'] text-sm leading-8">
            صلاحياتك الحالية لا تسمح بعرض هذه الصفحة. تواصلي مع المدير التنفيذي
            في حال كنت بحاجة لتوسيع صلاحياتك.
          </p>
        </div>
      </div>
    );
  }

  return children;
};
